import React, { useContext } from 'react';
import { ClassroomContext } from '../../context/ClassroomContext';
import styles from './styles/ClassroomSettings.module.css';

const ClassroomSettings = () => {
    const { classroom, isOwner, deleteClassroom } = useContext(ClassroomContext);

    const handleDeleteClassroom = () => {
        if (classroom && window.confirm('Are you sure you want to delete this classroom? This action cannot be undone.')) {
            deleteClassroom(classroom._id); 
        }
    };

    return (
        <div className={styles.settingsContainer}>
            <h1 className={styles.header}>Settings</h1>
            {isOwner ? (
                <>
                    <h2 className={styles.subHeader}>Owner Settings</h2>
                    <button 
                        className={`${styles.button} ${styles.deleteButton}`} 
                        onClick={handleDeleteClassroom}
                    >
                        Delete Classroom
                    </button>
                </>
            ) : (
                <h2 className={styles.subHeader}>Member Settings</h2>
            )}
        </div>
    );
};

export default ClassroomSettings;